export const aboutData = {
  brandName: '注册送彩金',
  brandIntro: '注册送彩金是国内领先的游戏娱乐福利平台，致力于为广大游戏爱好者提供最优质的注册彩金福利和游戏娱乐资讯服务。自成立以来，我们始终秉持"让每一位玩家都能享受到超值福利"的理念，为数百万用户提供了便捷、安全、高效的彩金领取服务。',
  mission: '我们的使命是打造中国最受信赖的游戏福利平台，通过持续优化注册送彩金活动的规则和体验，让更多玩家能够以零成本的方式体验到高品质的游戏娱乐内容。',
  vision: '成为游戏娱乐行业的标杆福利平台，推动行业透明化和规范化发展，建立玩家与平台之间的信任桥梁。',
  history: [
    { year: '2021', event: '平台正式上线，推出首期注册送彩金活动，吸引首批1万名用户注册参与。' },
    { year: '2022', event: '用户突破10万，新增棋牌游戏和真人娱乐彩金体验项目，合作平台扩展至30余家。' },
    { year: '2023', event: '完成品牌升级，推出VIP会员体系，注册送彩金活动累计发放金额突破1亿元。' },
    { year: '2024', event: '用户突破50万，新增体育竞猜和彩票游戏彩金项目，荣获行业最佳服务奖。' },
    { year: '2025', event: '用户突破100万，上线智能推荐系统，根据用户偏好精准匹配最优彩金活动。' },
    { year: '2026', event: '平台全面升级，注册送彩金活动金额和种类进一步丰富，用户体验持续优化。' },
  ],
  reputation: [
    {
      id: 1,
      name: '张先生',
      avatar: '张',
      rating: 5,
      comment: '注册送彩金的活动真的很良心，我注册后几分钟就收到了88元彩金，已经成功提现了。客服态度也很好，有问题随时都能得到解答。强烈推荐给身边的朋友们！',
      date: '2026-08-06',
    },
    {
      id: 2,
      name: '李女士',
      avatar: '李',
      rating: 5,
      comment: '对比了很多平台，注册送彩金这个平台的彩金福利确实是最实在的。流水要求合理，游戏选择也多，特别喜欢他们的电子游艺专区，画面精美体验好。',
      date: '2026-08-03',
    },
    {
      id: 3,
      name: '王先生',
      avatar: '王',
      rating: 5,
      comment: '作为老玩家，见证了这个平台一步步的成长。现在的注册送彩金活动越来越丰富，老用户也有回馈福利。平台的稳定性和安全性一直很可靠，值得信赖。',
      date: '2026-07-30',
    },
    {
      id: 4,
      name: '赵女士',
      avatar: '赵',
      rating: 4,
      comment: '第一次参加注册送彩金活动还有点担心，没想到流程这么简单透明。到账快、使用方便，已经推荐了好几个朋友一起来玩了。希望平台越来越好！',
      date: '2026-07-28',
    },
    {
      id: 5,
      name: '陈先生',
      avatar: '陈',
      rating: 5,
      comment: '用了大半年了，每次节日活动都有额外的彩金福利。平台的信誉没得说，提现也很及时。最让我满意的是游戏种类越来越多，总有新鲜感。',
      date: '2026-07-25',
    },
    {
      id: 6,
      name: '刘先生',
      avatar: '刘',
      rating: 5,
      comment: '从注册到现在体验非常好，彩金到账速度秒级，游戏流畅不卡顿。客服24小时在线，深夜遇到问题也有人解答。真心推荐这个平台！',
      date: '2026-07-22',
    },
  ],
  contactInfo: {
    phone: '400-888-8888',
    email: 'service@zhucecaijin.com',
    wechat: 'zhucecaijin888',
    qq: '88888888',
    address: '中国（上海）自由贸易试验区',
    workingHours: '周一至周日 09:00 - 24:00（全年无休）',
  },
};